// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const Labels = t.struct({
    cityLabel: t.String,
    postalCodeLabel: t.String,
    stateLabel: t.String
}, {
    defaultProps: {
        cityLabel: '',
        postalCodeLabel: '',
        stateLabel: ''
    },
    name: 'DigitalUserSearchLabels',
    strict: true
});
